module.exports = __webpack_public_path__ + "img/DK18976439.dc244707.png";